<template>
  <div>
    <div v-if="company == 1" style="height: 50px;">
      <Col span="4" style="padding-right:10px">
        <Select
          v-model="companyId"
          filterable
          :placeholder="$t('alarms.common.pleaseSelectCompany')"
          :transfer="true"
        >
          <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
          <Option :value="item.id" v-for="item in companyList" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Button
          type="primary"
          v-hasPermission="['network:cenMonitor:page']"
          @click="getSlbData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableSlbDate"
      style="width: 100.1%"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="slbDelmodal = true"
            v-hasPermission="['network:slbMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['network:slbMonitor:detail']"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="slbDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ vpcId }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeSLB()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import { getCookie } from "../../../../utils/cookieUtil";
var tableSlbVue = {};
export default {
  name: "TableSlb",
  data() {
    return {
      companyId: "",
      company: getCookie(global.companyId),
      companyList: [],
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      slbDelmodal: false,
      isDisable: false,
      modal_loading: false,
      vpcId: "",
      val: "",
      region: "",
      columns: [
        {
          title: this.$t("RAM.ALI.ElasticLoadBalancer.ELBName"),
          key: "name"
        },
        {
          title: this.$t("alarms.common.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.common.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.network.loadBalancing.DNSName"),
          key: "dnsName"
        },
        {
          title: "VPC ID",
          key: "vpcId"
        },
        {
          title: this.$t("alarms.network.loadBalancing.LBType"),
          key: "loadbalancerType"
        },
        {
          title: this.$t("alarms.network.loadBalancing.status"),
          key: "stateName"
        },
        // {
        //     title: this.$t('alarms.network.loadBalancing.loadbalancerId'),
        //     key: 'loadbalancerId'
        // },
        // {
        //     title: this.$t('alarms.network.loadBalancing.ip'),
        //     key: 'address'
        // },
        {
          title: this.$t("alarms.network.loadBalancing.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "detail"
        }
      ],
      tableSlbDate: []
    };
  },
  beforeCreate: function() {
    tableSlbVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableSlbVue.companyId = val;
    });
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    showAll: function() {
      tableSlbVue.getSlbData();
    },
    // 分页显示数据
    /****************************************************/
    getSlbData: function() {
      //列表分页
      this.$api.loadBalancer
        .pageLoadBalancer({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableSlbVue.companyId
        })
        .then(res => {
          this.tableSlbDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSlbVue.getSlbData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSlbVue.getSlbData();
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.vpcId = this.tableSlbDate[index].vpcId;
    },
    removeSLB: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.loadBalancer
        .deleteLoadBalancer("id", this.tableSlbDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableSlbVue.getSlbData();
            this.isDisable = false;
            this.modal_loading = false;
            this.slbDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/network/slbDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          accountType: row.accountType,
          loadbalancerId: row.loadbalancerId,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName,
          name: row.name,
          loadbalancerType: row.loadbalancerType,
          loadBalancerArn: row.loadBalancerArn,
          monitorModule: row.monitorModule
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/slb/TableSlb.vue